/**
 * 管理员注册页
 */
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Form, Input, Button, Card, message, Divider } from 'antd';
import { UserAddOutlined } from '@ant-design/icons';
import { authApi } from '../services/api';
import { useSystemConfig } from '../config/system';

export default function Register() {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const sysConfig = useSystemConfig();

  const handleRegister = async () => {
    try {
      const values = await form.validateFields();
      if (values.password !== values.confirmPassword) {
        return message.error('两次输入的密码不一致');
      }
      setLoading(true);
      const res = await authApi.register({
        username: values.username,
        password: values.password,
        realName: values.realName,
        phone: values.phone,
        registerCode: values.registerCode,
      });
      if (res.code === 200) {
        message.success('注册成功，请登录');
        navigate('/login');
      } else {
        message.error(res.message || '注册失败');
      }
    } catch (err) {
      if (err.response?.data?.message) {
        message.error(err.response.data.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f0f2f5',
    }}>
      <Card style={{ width: 400, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <UserAddOutlined style={{ fontSize: 36, color: '#1677ff' }} />
          <h2 style={{ margin: '12px 0 4px' }}>员工注册（需注册码）</h2>
          <div style={{ color: '#999' }}>{sysConfig.systemTitle}</div>
        </div>

        <Form form={form} layout="vertical" size="large">
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input placeholder="用户名" allowClear />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: '请输入密码' },
              { min: 6, message: '密码至少6位' },
            ]}
          >
            <Input.Password placeholder="密码（至少6位）" allowClear />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            rules={[{ required: true, message: '请再次输入密码' }]}
          >
            <Input.Password placeholder="确认密码" allowClear />
          </Form.Item>

          <Form.Item name="realName">
            <Input placeholder="真实姓名（选填）" allowClear />
          </Form.Item>

          <Form.Item name="phone">
            <Input placeholder="手机号（选填）" allowClear />
          </Form.Item>

          <Form.Item
            name="registerCode"
            rules={[{ required: true, message: '请输入注册码' }]}
          >
            <Input placeholder="注册码（向管理员索取）" allowClear />
          </Form.Item>

          <Form.Item>
            <Button type="primary" block loading={loading} onClick={handleRegister}>
              注册
            </Button>
          </Form.Item>
        </Form>

        <Divider plain>已有账号？</Divider>
        <Button type="link" block onClick={() => navigate('/login')}>
          立即登录
        </Button>
      </Card>
    </div>
  );
}
